export default "__VITE_ASSET__8061d762__"